/**
 * Trunnion AI - Clearance Selector
 * Classification level dropdown.
 */

import { Shield } from 'lucide-react';
import { CLASSIFICATION_CONFIG, CLASSIFICATION_LEVELS } from '@/config/constants';
import type { ClassificationLevel } from '@/types';

interface ClearanceSelectorProps {
  value: ClassificationLevel;
  onChange: (level: ClassificationLevel) => void;
  maxLevel?: ClassificationLevel;
  label?: string;
  disabled?: boolean;
}

export function ClearanceSelector({
  value,
  onChange,
  maxLevel,
  label = 'Classification Level',
  disabled = false,
}: ClearanceSelectorProps) {
  const maxRank = maxLevel ? CLASSIFICATION_CONFIG[maxLevel].rank : 4;
  const availableLevels = CLASSIFICATION_LEVELS.filter(
    (level) => CLASSIFICATION_CONFIG[level].rank <= maxRank,
  );

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-trunnion-slate-200">
        {label}
      </label>
      <div className="relative">
        <Shield className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-trunnion-slate-400" />
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as ClassificationLevel)}
          disabled={disabled}
          className="w-full appearance-none rounded-lg border border-trunnion-slate-600 bg-trunnion-slate-800 py-2 pl-10 pr-8 text-sm text-white hover:border-trunnion-slate-500 focus:outline-none focus:ring-2 focus:ring-trunnion-gold-500 disabled:opacity-50"
        >
          {availableLevels.map((level) => (
            <option key={level} value={level}>
              {CLASSIFICATION_CONFIG[level].label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
